<template lang="html">

    <section class="comunicaciones">
      <h1>Comunicaciones</h1>

      <div class="comunicaciones-list container -xs">


          <article class="comunicacion">

            <main>

              <h5 class="fecha">11/11/2011</h5>

              <h2>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</h2>
              
            </main>

            <div class="details">

              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugiat nobis sit dolorum dolorem? Perferendis dolores eos, harum quidem, nesciunt rerum laboriosam quis dignissimos, incidunt blanditiis provident non est sunt in!</p>

              <a href="" class="link">Ver más</a>

            </div>

          </article>


          <article class="comunicacion" :show="true">

            <main>

              <h5 class="fecha">11/11/2011</h5>

              <h2>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</h2>
              
            </main>

            <div class="details">

              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugiat nobis sit dolorum dolorem? Perferendis dolores eos, harum quidem, nesciunt rerum laboriosam quis dignissimos, incidunt blanditiis provident non est sunt in!</p>

              <a href="" class="link">Ver más</a>

            </div>

          </article>
        

      </div>

      <a :href="$t('portalalumno')" class="btn">Ver más</a>

    </section>
  
  </template>
  
  <script lang="js">

    import {mapActions} from 'vuex';

    export default  {
      name: 'comunicaciones',
      mounted(){
        this.requestComunicaciones().then( r =>{
          this.data = r;
        })
      },
      data(){
        return{
          data : ''
        }
      },
      methods: {
         ...mapActions(['requestComunicaciones'])
      },
  }
  </script>
  
  <style scoped lang="scss">
    .comunicaciones {
  
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/view-parts/home/comunicaciones.vue